import { ResponsiveValue } from '@gousto-internal/citrus-react'

import GoustoPng from 'routes/Home/PriceComparisonTable/assets/Gousto.png'
import GoustoWebp from 'routes/Home/PriceComparisonTable/assets/Gousto.webp'
import HelloFreshPng from 'routes/Home/PriceComparisonTable/assets/HelloFresh.png'
import HelloFreshWebp from 'routes/Home/PriceComparisonTable/assets/HelloFresh.webp'
import MindfulChefPng from 'routes/Home/PriceComparisonTable/assets/MindfulChef.png'
import MindfulChefWebp from 'routes/Home/PriceComparisonTable/assets/MindfulChef.webp'

export const welcomeSectionTexts = {
  heading: 'Biggest menu, lowest price',
  subheading: 'Wondering how Gousto compares to other recipe box brands? Look no further.',
}

export const comparisonTableTexts = {
  tableHeading: 'Comparison of average prices',
  tableFooter:
    'Based on average prices of a 4 recipe 2 person box for all available meals, includes delivery fees and premium recipe surcharges. Read full details:',
  tableFooterLink: {
    text: 'Value verification',
    href: 'https://cook.gousto.co.uk/value/',
  },
}

export const BLOCK_WIDTH_LIST: ResponsiveValue<string> = ['21.5rem', '36.5rem', '52%', '50%']

export const recipeBrandsData = [
  {
    brandName: 'Gousto',
    nextGenImage: GoustoWebp,
    fallbackImage: GoustoPng,
    price: '40.93',
    noOfRecipes: 75,
  },
  {
    brandName: 'Hello Fresh',
    nextGenImage: HelloFreshWebp,
    fallbackImage: HelloFreshPng,
    price: '43.47',
    noOfRecipes: 44,
  },
  {
    brandName: 'Mindful Chef',
    nextGenImage: MindfulChefWebp,
    fallbackImage: MindfulChefPng,
    price: '61.70',
    noOfRecipes: 20,
  },
]
